import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";

export class CustomNotification extends Notification {
	public async onClick(vue: Vue): Promise<INotificationOnClickResult> {
		if (!this.Data) return {};
		if (typeof(this.Data.href) != "string") return {};
		if (this.Data.href.startsWith("/")) {
			return {routeTo: this.Data.href};
		}
		window.location = this.Data.href;
		return {};
	}

	public getActionKey():string {
		if (!this.Data || typeof(this.Data.href) != "string") return "";
		return "open";
	}
}
